import { render, staticRenderFns } from "./LadaNewItemCard.vue?vue&type=template&id=b448e68c&scoped=true&"
import script from "./LadaNewItemCard.vue?vue&type=script&lang=js&"
export * from "./LadaNewItemCard.vue?vue&type=script&lang=js&"
import style0 from "./LadaNewItemCard.vue?vue&type=style&index=0&id=b448e68c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b448e68c",
  null
  
)

export default component.exports